import Axios from "../baseApi";
export default {
  async fetch() {
    return await Axios.get('/api-master-data/v1/businessMode');
  },
  async create(data) {
    try{
      const response = await Axios.put('/api-master-data/v1/businessMode', data);
      return response.data;
    } catch (error) {
      return await Promise.reject(error);
    }
  },
  async update(id, data) {
    try{
      const response = await Axios.post('/api-master-data/v1/businessMode/' + id, data);
      return response.data;
    } catch (error) {
      return await Promise.reject(error);
    }
  },
  async delete(id) {
    try{
      const response = await Axios.delete('/api-master-data/v1/businessMode/' + id);
      return response.data;
    } catch (error) {
      return await Promise.reject(error);
    }
  }
}
